module.exports = __webpack_public_path__ + "img/icon_upload.65adbe1c-1433ffe3.86cba364.svg";